import React from 'react';
import { Link } from '@sitecore-jss/sitecore-jss-react';

const EditableLink = ({ linkField, isEditing }) => {
  if (isEditing) {
    return (
      <>
        <br />
        <Link field={linkField} />
      </>
    );
  }
  return <></>;
};

export default EditableLink;
